// extracted by mini-css-extract-plugin
export var card = "styles-module--card--3s2np";
export var card_inner = "styles-module--card_inner--2iMbl";
export var card_icon = "styles-module--card_icon--2KPTL";
export var card_title = "styles-module--card_title--3gGsF";